<template>
  <b-modal id="login-modal" size="sm" ref="login-modal" hide-footer
           :title="$t('login.modal.title')"
           header-close-variant="white"
           no-close-on-backdrop
           header-class="border-0"
           content-class="border-0" centered >
    <div class="row">
      <form class="login-form ml-3 mr-3" @submit.prevent="login">
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group">
              <label>{{$t('login.email')}} <span class="text-danger">*</span></label >
              <div class="position-relative">
                <user-icon class="fea icon-sm icons"></user-icon>
                <input
                    type="email"
                    v-model="email"
                    class="form-control pl-5"
                    @focus="showTip=false"
                    :placeholder="$t('login.emailTip')"
                    name="email"
                    required=""
                />
              </div>
            </div>
          </div>

          <div class="col-lg-12">
            <div class="form-group">
              <label>{{$t('login.password')}}<span class="text-danger">*</span></label >
              <div class="position-relative">
                <key-icon class="fea icon-sm icons"></key-icon>
                <input
                    type="password"
                    v-model="password"
                    @focus="showTip=false"
                    class="form-control pl-5"
                    :placeholder="$t('login.passwordTip')"
                    required=""
                />
              </div>
            </div>
          </div>

          <div class="col-lg-12 mb-0">
            <div v-if="showTip" class="alert " :class="{'alert-danger': !isSuccess, 'alert-success': isSuccess}" role="alert">
              <i v-if="isSuccess" class="uil uil-check"></i>
              <i v-if="!isSuccess" class="uil uil-times"></i>
              {{message}}
            </div>
            <button :disabled="loading" class="btn btn-primary btn-block">{{$t('login.title')}}</button>
          </div>
          <div class="col-12 text-center mt-2">
              <router-link to="/auth-re-password" class="text-primary">{{$t('login.forgot_pass')}}</router-link>
              <router-link to="/auth-signup" class="text-primary ml-2" >{{$t('login.signup')}}</router-link >
          </div>
        </div>
      </form>

    </div>
  </b-modal>
</template>

<script>
import axios from "axios";
import config from "@/config.json";
import { HomeIcon, UserIcon, KeyIcon } from "vue-feather-icons";
import {host, post} from "@/assets/js/utils";

export default {
  name: "login-modal",
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      showTip: false,
      isSuccess: false,
      message: "",
    }
  },
  methods: {
    async login() {
      this.loading = true;
      if (this.email.trim() === "" || this.password.trim() === "") {
        return;
      }
      const {email, password} = this;

      try {
        const data = await post(`${config.api.login}`, {email, password});
        console.log(data);
        if (data.errno === 0) {
          localStorage.setItem("access_key", data['access_key']);
          localStorage.setItem("access_token", data['access_token']);
          this.showTip = true;
          this.isSuccess = true;
          this.message = this.$t('login.login_success');
          setTimeout(() => {
            this.$emit("onLoginSuccess");
          }, 1000);
        } else {
          this.loading = false;
          this.showTip = true;
          this.isSuccess = false;
          this.message = data.info
        }
      } catch (e) {
        this.loading = false;
        this.showTip = true;
        this.isSuccess = false;
        this.message = e.toString();
      }
    }
  },
  components: {
    HomeIcon,
    UserIcon,
    KeyIcon,
  },
}
</script>

<style scoped>

</style>
